import { Scene } from "three";
// this is not used anymore as we want to customize it
// import { ARButton } from "./node_modules/three/examples/jsm/webxr/ARButton.js";
import { CustomARButton } from "./helpers/CustomARButton.js";
import ArrayItem from "./scene/array-item.class.js";
import { updateCode } from "./helpers/code.js";
import { createRenderer } from "./helpers/renderer.js";
import { createCamera } from "./helpers/camera.js";
import { createLight } from "./helpers/light.js";
import { OrbitControls } from "./node_modules/three/examples/jsm/controls/OrbitControls.js";
import "./vendor/prism.js";

let index = 0;
const CUBES = [];
let STEPS = [];
let SUBJECT = [];

SUBJECT = [5, 3, 8];

const editIcon = document.querySelector("#edit-array");
editIcon.addEventListener("click", () => {
  const input = prompt("Enter an array that you'd like to visualize");
  try {
    SUBJECT = JSON.parse(input);

    const reason = validationFails(SUBJECT);
    if (reason) {
      return alert(reason);
    }
    updateCode(SUBJECT);
  } catch (error) {
    alert(
      "This does not seem to be a valid array. Make sure it starts with [ and ends with ]. For example: [1, 8, 3]"
    );
  }
});

function nth(number) {
  const values = {
    2: "second",
    3: "third",
    4: "fourth",
    5: "fifth",
    6: "sixth",
    7: "seventh",
    8: "eighth",
    9: "nineth",
    10: "tenth",
    11: "eleventh",
    12: "twelfth",
    13: "thirtheenth",
    14: "fourteenth",
    15: "fifteenth",
  };
  return values[number];
}

const getHumanReadablePositionFromIndex = (index, array) => {
  if (index === 0) {
    return "first element";
  }
  if (index === array.length - 1) {
    return `${nth(index + 1)} (last) element`;
  }

  return nth(index + 1) + " element";
};

const generateSteps = () => {
  const steps = [];

  // before the forEach, define the one that resets
  steps.push({
    code: ``, // first one is always empty (at least for arrays)
    draw: function () {
      CUBES.forEach((cube) => cube.material.color.setHex(0x616161));
      CUBES.forEach((cube) => cube.scale.set(1, 1, 1));
    },
  });

  let index = 0;
  SUBJECT.forEach((item, index) => {
    function handleDraw(step) {
      console.debug({ step });
      if (CUBES[step]) {
        if (step >= 0) {
          CUBES.forEach((cube) => cube.material.color.setHex(0x616161));
          CUBES.forEach((cube) => cube.scale.set(1, 1, 1));
        }
        CUBES[step].material.color.setHex(0xff0000);
        CUBES[step].scale.set(1.08, 1.08, 1);
      }
    }

    steps.push({
      code: `data[${index}] // ${getHumanReadablePositionFromIndex(
        index,
        SUBJECT
      )}`,
      draw: handleDraw.bind(this, index),
    });
    index++;
  });

  return steps;
};

let scene;
let camera;
let renderer;
let light;
let handleSelect;

const validationFails = (array) => {
  if (!Array.isArray(array)) {
    return "Not an array. Make sure it starts with [ and ends with ]. For example: [1, 8, 3]";
  }

  if (array.length === 0) {
    return "Please enter an array with at least one item.";
  }

  // has to be first because typeof array will return object
  const hasNestedArrays = array.some((item) => Array.isArray(item));
  if (hasNestedArrays) {
    return "Nested arrays are not supported in this visualization.";
  }

  const hasUndefined = array.some((item) => typeof item === "undefined");
  if (hasUndefined) {
    return "undefined is not supported as array item in this visualization.";
  }

  const hasSymbol = array.some((item) => typeof item === "symbol");
  if (hasSymbol) {
    return "Sumbols are not supported as array items in this visualization.";
  }

  const hasNull = array.some((item) => item === null);
  if (hasNull) {
    return "null is not supported as array item in this visualization.";
  }

  const hasFunctions = array.some((item) => typeof item === "function");
  if (hasFunctions) {
    return "Functions are not supported as array items in this visualization.";
  }

  // keep this at the end
  const hasObjects = array.some((item) => typeof item === "object");
  if (hasObjects) {
    return "Objects are not supported as array items in this visualization.";
  }

  // don't allow more than 15 items
  if (array.length > 15) {
    return "Please limit your array to 15 items.";
  }

  return false;
};

const init = () => {
  const arrayItem = new ArrayItem();

  scene = new Scene();
  camera = createCamera();
  renderer = createRenderer();
  light = createLight();
  scene.add(light);

  const controller = renderer.xr.getController(0);
  handleSelect = function () {
    editIcon.remove();
    SUBJECT.forEach((item, index) => {
      const result = arrayItem.create(controller.matrixWorld, item, index);

      scene.add(result.cube);
      scene.add(result.letter);
      scene.add(result.arrayIndex);
      CUBES.push(result.cube);
    });

    STEPS = generateSteps();

    initUI();

    controller.removeEventListener("select", handleSelect);
  };
  controller.addEventListener("select", handleSelect);
  scene.add(controller);

  renderer.setAnimationLoop(function () {
    renderer.render(scene, camera);
  });

  CustomARButton.createButton(
    renderer,
    {
      optionalFeatures: ["dom-overlay"],
      domOverlay: { root: document.querySelector("#dom-overlay") },
    },
    switchToDesktopMode
  );

  updateCode(SUBJECT);
};

const initUI = () => {
  const next = document.querySelector("#next");
  const prev = document.querySelector("#prev");
  next.removeAttribute("hidden");
  prev.removeAttribute("hidden");

  next.addEventListener("click", () => {
    index++;
    updateCode(SUBJECT, STEPS[index].code);
    STEPS[index].draw();
    if (index >= STEPS.length - 1) {
      next.setAttribute("disabled", "disabled");
    } else {
      next.removeAttribute("disabled");
    }
    if (index > 0) {
      prev.removeAttribute("disabled");
    }
  });

  prev.addEventListener("click", () => {
    index--;
    updateCode(SUBJECT, STEPS[index].code);
    STEPS[index].draw();
    if (index <= 0) {
      prev.setAttribute("disabled", "disabled");
    }
    next.removeAttribute("disabled");
  });
};

init();

function switchToDesktopMode() {
  handleSelect();
  document.querySelector("#ar-instructions").remove();

  // change position/zoom/rotation
  camera.position.x = -0.04601436848136343;
  camera.position.y = 0;
  camera.position.z = 0.13697319368760766;

  document.body.appendChild(renderer.domElement);
  new OrbitControls(camera, renderer.domElement);
  document.querySelector("#touch-panning").classList.add("show");
  document.querySelector("#start-button").remove();
}
